export const consumerOrderTexts = (
    state = {
		consumerOrderDeliveryText: '',
		consumerOrderCancelModalText: '',
		consumerOrderResellerDeliveryModalText: '',
		consumerOrderBrafabDeliveryText: '',
		consumerOrderBrafabResellerDeliveryText: ''
    }) => { return state; };